module.exports = __webpack_public_path__ + "static/img/zzsq.cda07c3c.png";